import React from 'react';
// import WeekAndDay from './Week&Day';
import Calendar from './Calendar';
import DayAndWeekSwitch from './DayWeekSwitch';
import { makeStyles } from '@material-ui/core';
// import Calendar from '../Calendar/index';
const styles = makeStyles({
    filterWrapper: {
        display: 'flex',
        alignItems: 'center'
    }
});

const AppointmentFilter = () => {
    const classes = styles();
    return (
        <div>
            <div className={classes.filterWrapper}>
                <DayAndWeekSwitch />
                <Calendar />
            </div>
        </div>
    );
};

export default AppointmentFilter;
